<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="">
      <a-form :form="form">
        <a-form-item label="活动id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <!-- <a-input-number v-decorator="['coupon_id', validatorRules.coupon_id]" :max="999999999999999999"
            placeholder="请输入活动id"
            style="width: 200px" /> -->
           <a-input v-decorator="['coupon_id', validatorRules.coupon_id]" 
            placeholder="请输入活动id"
            style="width: 200px"></a-input>
        </a-form-item>
        <a-form-item label="生日祝福接口异常推送"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['coupon_issue_error_notigy_user_no', validatorRules.coupon_issue_error_notigy_user_no]"
            placeholder="请输入生日祝福接口异常推送"
            style="width: 200px" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
          :wrapperCol="{ span: 12, offset: 5 }">
          <div style="display: flex;justify-content: center;">
            <a-button type="primary"
              @click="handleOk"
              html-type="submit">
              保存
            </a-button>
          </div>

        </a-form-item>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import { getAction, httpAction } from '@/api/manage'
import pick from 'lodash.pick'
export default {
  name: "BusEkpEntryorbothConfigList",
  data() {
    return {
      description: 'bus_ekp_entryorboth_config管理页面',
      form: this.$form.createForm(this),
      // 表头
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      validatorRules: {
        coupon_id: {
          rules: [
            { required: true, message: '请输入活动id!' },
          ]
        },
        coupon_issue_error_notigy_user_no: {
          rules: [
            { required: true, message: '请输入生日祝福接口异常推送!' },
          ]
        },
      },
      url: {
        queryByKeys: "/customer/birthday/busEkpEntryorbothConfig/queryByKeys",
        saveDates: "/customer/birthday/busEkpEntryorbothConfig/saveDates"
      },
      dictOptions: {},
    }
  },
  computed: {
  },
  created() {

  },
  mounted() {
    const that = this;
    let obj = { keys: 'coupon_id,coupon_issue_error_notigy_user_no' }
    getAction(this.url.queryByKeys, obj).then(res => {
      console.log(res);
      if (res.success) {
        // let resultObj = {
        //   coupon_id: res.result.coupon_id,
        //   coupon_issue_error_notigy_user_no: res.result.coupon_issue_error_notigy_user_no
        // }
        // console.log(resultObj);
        that.$nextTick(() => {
          that.form.setFieldsValue(
            pick(res.result, 'coupon_id', 'coupon_issue_error_notigy_user_no'
            )
          )
        })
      } else {
        that.$message.warning(res.message)
      }
    })
  },
  methods: {
    handleOk(val) {
      console.log(val);
      const that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          let list = [];
          console.log(values);
          Object.keys(values).forEach(function(key) {
            let obj = {
              configKey: key,
              configValue: values[key]
            }
            list.push(obj)
          })
          console.log(list);
          httpAction(that.url.saveDates, list, 'post').then(res => {
            console.log(res);
            if (res.success) {
              that.$message.success("修改配置成功!");
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    },

  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>